import { ERROR_CODE as s } from "../../constants/error.js";
import { WalletType as n } from "../../constants/web3.js";
import { useAccountContext as m } from "../../contexts/account/AccountContext.js";
import { useMessageContext as p } from "../../contexts/share/MessageContext.js";
import { CustomError as u } from "../../errors/customError.js";
import a from "./useErrorHandler.js";
import { useCallback as i } from "react";
const R = () => {
  const { getErrorMessage: r } = a(), { showGeneralError: t } = p(), { setMissWallet: e } = m();
  return {
    showErrorPopup: i(
      (o) => {
        if (o instanceof u && o.code === s.LOGIN.NOT_YET_INSTALL_WALLET) {
          e(n.Ronin);
          return;
        }
        t(r(o));
      },
      [r, t, e]
    )
  };
};
export {
  R as default
};
//# sourceMappingURL=useErrorPopup.js.map
